import {
    PaperEdgesAction
} from "../actions";
import {Edge} from "../model";


const PaperEdges = (state: Array<Edge> = [], action: PaperEdgesAction) => {
    switch (action.type) {
        case "INIT_PAPER_EDGES":
            return action.initialState;
        default:
            return state;
    }
};

export default PaperEdges;